import { Button as BsButton, ButtonProps as BsButtonProps } from "react-bootstrap";
import { buttonCls } from "./Theme";

export interface ButtonProps extends BsButtonProps {
    className?: string;
    override?:  boolean;
}

export function Button( { override, className = "", children, ...rest }: ButtonProps ) {
    const clsName = override ? className : `${className} ${buttonCls}`;
    return <BsButton className={clsName} {...rest}>
        {children}
    </BsButton>;
}